<script lang="ts">
  import { rgbaToHex } from "@/libs/color"
  import QR from "qrcode"

  export let value: string
  export let size: number
  export let alt = ""

  let img: string | null
  let el: HTMLElement | null = null

  $: QR.toDataURL(value, {
    width: size * window.devicePixelRatio,
    color: { dark: el ? rgbaToHex(getComputedStyle(el).color) : "#000", light: "#0000" },
  }).then((qr) => (img = qr))
</script>

{#if img}
  <img bind:this={el} src={img} style:width={size} {alt} class={$$props.class} />
{:else}
  <span bind:this={el}></span>
{/if}
